import type { AsyncData } from '#app';
import type {
    HomeQuery,
    PageQuery,
    UpdateQuery,
    CollectionQuery,

    HomeEntryTypeFragment,
    PageEntryTypeFragment,
    ProgramOverviewEntryTypeFragment,
    CollectionEntryTypeFragment,
    UpdateEntryTypeFragment
} from '~/types/craft-schema';

type CraftQuery = HomeQuery | PageQuery | CollectionQuery | UpdateQuery;
type CraftEntryType = HomeEntryTypeFragment | PageEntryTypeFragment | ProgramOverviewEntryTypeFragment | CollectionEntryTypeFragment | UpdateEntryTypeFragment;

export function useCraftEntry<ResT extends CraftEntryType>({ error, data, status }: AsyncData<CraftQuery, any>, applySeo: boolean = true): ComputedRef<ResT | undefined>  {
    const entry = computed(() => data.value?.entry as ResT | undefined);

    if (applySeo && entry.value) {
        const entrySeoData = computed(() => entry.value?.seo);

        useHead(parseEntrySeo(entrySeoData.value));
    }

    watchEffect(() => {
        if (status.value === 'pending') {
            // Don't do anything while loading
            return;
        }

        if (!entry?.value && unref(error)) {
            throw createError({
                statusCode: error.value?.statusCode || -1,
                statusMessage: error.value?.statusMessage || 'Internal server error',
            });
        } else if (!entry?.value) {
            throw createError({ statusCode: 404, statusMessage: 'Page Not Found' });
        }
    });

    return entry;
}
